<template>
  <div class="invite-share">
    <img src="../../static/img/new-invite/share.jpg" ref="img" />
    <img src="../../static/img/new-invite/share-icon.png" ref="icon" />
    <canvas width="750" height="1080" ref="canvas"></canvas>
  </div>
</template>

<script>
import qrcode from 'jr-qrcode';
import env from '../services/dev';

export default {
  props: ['price', 'mobilePhone', 'shareParam'],

  data() {
    return {};
  },

  methods: {
    drawInit() {
      const img = this.$refs.img;

      img.onload = () => this.draw();
    },

    draw() {
      const canvas = this.$refs.canvas;
      const img = this.$refs.img;
      const icon = this.$refs.icon;
      const ctx = canvas.getContext('2d');

      ctx.drawImage(img, 0, 0, 750, 1080);

      // 以帮助多少人出签
      ctx.font = '20px 微软雅黑';
      ctx.fillStyle = '#6f6f6f';
      ctx.fillText('已帮助', 123, 104);
      const signOutAmount = `${this.shareParam.sign_out_amount}人`; // 办签人数
      ctx.fillStyle = '#ff5a60';
      ctx.fillText(
        signOutAmount,
        123 + ctx.measureText('已帮助').width + 5,
        104,
      );
      ctx.fillStyle = '#6f6f6f';
      ctx.fillText(
        '成功出签！',
        123 +
          ctx.measureText('已帮助').width +
          5 +
          ctx.measureText(signOutAmount).width +
          5,
        104,
      );

      // 国家价格
      const countryList = [
        {
          price: this.shareParam.japan_lowest_price / 100, // 日本
          left: 143,
        },
        {
          price: this.shareParam.thailand_lowest_price / 100, // 泰国
          left: 376,
        },
        {
          price: this.shareParam.united_states_lowest_price / 100, // 美国
          left: 606,
        },
      ];
      countryList.forEach((item) => {
        ctx.font = 'bold 20px 微软雅黑';
        const unitWidth = ctx.measureText('￥').width;
        const labelWidth = ctx.measureText('起').width;
        ctx.font = 'bold 34px 微软雅黑';
        const priceWidth = ctx.measureText(item.price).width;
        const left = item.left - (unitWidth + labelWidth + priceWidth + 5) / 2; // 为了文字可以居中，所以需要算出来left是多少

        ctx.font = 'bold 20px 微软雅黑';
        ctx.fillStyle = '#ff4b4d';
        ctx.fillText('￥', left, 736);
        ctx.font = 'bold 34px 微软雅黑';
        ctx.fillText(item.price, left + unitWidth, 736);
        ctx.font = 'bold 20px 微软雅黑';
        ctx.fillText('起', left + unitWidth + priceWidth + 5, 734);
      });

      // 金额
      ctx.font = 'bold 88px 微软雅黑';
      ctx.fillStyle = 'white';
      ctx.fillText(this.price, 335, 385);

      // 单位
      ctx.font = 'bold 48px 微软雅黑';
      ctx.fillText('￥', 293, 382);

      const url = `https://${env}h5.11visa.com/#/invite?mobile_phone=${this.mobilePhone}`;
      const base64 = qrcode.getQrBase64(url, {
        width: 200,
        height: 200,
        padding: 0,
      });
      const codeImg = new Image();
      codeImg.onload = () => {
        ctx.drawImage(codeImg, 100, 840);
        ctx.drawImage(icon, 170, 910, 62, 62);

        const result = canvas.toDataURL('image/jpeg');
        this.$emit('input', result.split('base64,')[1]);
      };
      codeImg.src = base64;
    },
  },

  mounted() {
    this.drawInit();
  },
};
</script>

<style lang="less" scoped>
.invite-share {
  position: absolute;
  left: -99999px;
}
</style>
